import { useTestimonials } from "@/hooks/useTestimonials";

interface Props {
  title?: string;
  subtitle?: string;
  limit?: number;
}

function Stars({ rating }: { rating: number }) {
  return (
    <div className="flex items-center gap-0.5 text-brand-gold">
      {[1, 2, 3, 4, 5].map((n) => (
        <i key={n} className={n <= rating ? "ri-star-fill" : "ri-star-line"}></i>
      ))}
    </div>
  );
}

export default function TestimonialsSection({ title, subtitle, limit }: Props) {
  const testimonials = useTestimonials();
  const items = limit ? testimonials.slice(0, limit) : testimonials;

  return (
    <section className="w-full bg-neutral-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-16 md:py-20">
        <div className="text-center">
          <span className="text-xs font-medium uppercase tracking-widest text-brand-gold">
            Reviews
          </span>
          <h2 className="mt-2 font-heading text-3xl md:text-4xl font-semibold uppercase text-brand-dark">
            {title || "What Our Customers Say"}
          </h2>
          {subtitle && (
            <p className="mx-auto mt-3 max-w-2xl text-sm text-neutral-600 leading-relaxed">
              {subtitle}
            </p>
          )}
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {items.map((tItem) => (
            <figure
              key={tItem.id}
              className="flex flex-col rounded-lg border border-neutral-200 bg-white p-6"
            >
              <div className="flex items-center justify-between">
                <Stars rating={tItem.rating} />
                <i className="ri-double-quotes-r text-3xl text-brand-gold/30"></i>
              </div>
              <blockquote className="mt-4 flex-1 text-sm text-neutral-600 leading-relaxed">
                &quot;{tItem.content}&quot;
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-neutral-100 pt-4">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-brand-dark text-brand-gold font-heading text-sm font-semibold uppercase">
                  {tItem.name.charAt(0)}
                </span>
                <div>
                  <p className="text-sm font-semibold text-brand-dark">{tItem.name}</p>
                  <p className="text-xs text-neutral-500">{tItem.location}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}